import { EmptyState } from "@merchant-trends/ds-ui";
import { useNavigate } from "react-router";
import { PORTAL_PATHS } from "../paths.js";

/** An unknown path inside the portal: keep the frame and offer the way back. */
export function NotFoundScreen() {
  const navigate = useNavigate();

  return (
    <EmptyState
      action={{
        label: "Go to Home",
        onClick: () => void navigate(PORTAL_PATHS.home),
      }}
      hint="The address may be mistyped, or the page may not exist in this version of Nexus."
      title="Page not found"
    />
  );
}
